export default __webpack_public_path__ + "static/media/heart.16b9490c.svg";